import { idsFilter, compareIds } from "utils/event/animate.js"
import { getAttrById, handleFindLayoutComponentOptionsCols, isEqual, isExist, isSsrPage } from "../index"
import { CATEGORY_MODE } from "../../consts"
// import { isExist } from "utils/index.js"

export default {
  data() {
    return {
      pageLoadAnimateClass: [],
      hoverAnimateClass: [],
      clickAnimateClass: [],
      pageLoadAnimateGroupClass:[],
      currentEl: undefined,
      hoverAnimateOptions:[],  // 特殊动画需要修改组件options的属性
      clickAnimateOptions:[]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.currentEl = this.$el
      if (this.currentEl.nodeType === 1) {
        this.mouseoverHandleAnimate()
        this.clickHandleAnimate()
        this.pageloadHandleAnimate()
        this.pageloadHandleAnimateGroup()
      }
    })
  },
  beforeDestroy() {
    this.$el.removeEventListener("pageScan", this.pageloadHandle)
    this.$el.removeEventListener("pageScan1", this.animateGroupHandle)
    this.$el.removeEventListener("scan", this.mouseenterHandle)
    this.$el.removeEventListener("clickScan", this.clickHandle)
  },
  computed: {
  },
  methods: {
    getAnimateOption(ids) {
      const rectAttr = getAttrById(this.$store.state[this.request_prefix], ids)
      if (ids.elementInDataGridId) { // 数据列表单元格内部组件
        return getAttrById(this.$store.state[this.request_prefix], ids, "elementInDataGrid")
      } else if (!ids.uid) {
        if (typeof ids.elementInAutoLayoutId === "number") {
          let attr = rectAttr
          if (typeof ids.directionIndex === "number") {
            attr = getAttrById(this.$store.state[this.request_prefix], ids, "elementInTitleOptions")?.options
          }
          return attr
        }
        if(isExist(ids.swiperContent_id)){
          // 轮播内的组件
          return getAttrById(this.$store.state[this.request_prefix], ids, "elementInSwiper")
        }else{
          return rectAttr.options
        }
      } else {
        if (ids.hasOwnProperty("elementInLayoutId")) {
          if (typeof ids.elementInAutoLayoutId === "number" && rectAttr.innerElement === "cxAutoLayout") {
            // 查找自由布局下的自动布局内的组件
            return rectAttr?.elementOptions?.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId)
          }
          // 自由布局组件内的 组件
          return rectAttr
        } else {
          // 布局内的单元格和行布局内的自由布局的单元格的获取回来的有差异
          const rectAttrOptions = rectAttr.options ?rectAttr.options :rectAttr
          const useActiveIndex = rectAttrOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttrOptions.activeIndex
          const pOptions = [rectAttrOptions.rows[useActiveIndex]]
          return handleFindLayoutComponentOptionsCols(pOptions, ids.uid).componentBoxOptions
        }
      }
    },
    // 获取动画的变量
    getAnimateGroupVariableStyle(options,ids,animateDom) {
      // 分离出当前组件的动画（自动+被动）
      let animateVariable = {}
      if(!options){
        options = this.getAnimateOption(ids)
      }
      let animatesTypes =options.animateGroup
      if(animateDom){
        animateDom.style.setProperty('--animateGroupDuration' ,animatesTypes.animateDuration + 'ms')
        animateDom.style.setProperty('--animateGroupDelay' ,animatesTypes.animateDelay + 'ms')
        if(animatesTypes.directionParameter && typeof animatesTypes.directionParameter === 'object'){
          for (let key in animatesTypes.directionParameter) {
            // 访问obj对象的属性，key为属性名
            animateDom.style.setProperty(`--animateGroup${animatesTypes.animateType}${key}` ,animatesTypes.directionParameter[key])
          }
        }
        if(options.rotate){
          animateDom.style.setProperty('--animateRotate' ,options.rotate + 'deg')
        }else{
          animateDom.style.removeProperty('--animateRotate')
        }
      }
    },
    getBackGroundStyle(background){
      let conatinerBg ={
        backgroundImage: "",
        backgroundSize: "",
        backgroundPosition: "",
        backgroundRepeat: ""
      }
      background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = conatinerBg.backgroundImage.length > 0 ? "," : ""
            conatinerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            conatinerBg.backgroundSize = bg.clipSize
            conatinerBg.backgroundPosition = bg.alignType
            conatinerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            conatinerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            if (bg.data.stops.length > 0) {
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            if (bg.data.stops.length > 0) {
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      let backgroundStyle = `${conatinerBg.backgroundImage} ${conatinerBg.backgroundRepeat} ${conatinerBg.backgroundPosition}`
      return backgroundStyle
    },
    // 获取动画的变量
    getAnimateVariableStyle(options,ids,animateDom,controlIds) {
      // 分离出当前组件的动画（自动+被动）
      let animateVariable = {}
      let animatesTypes =options? ["pageloadAnimates"]: ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
      if(!options){
        options = this.getAnimateOption(ids)
      }
      animatesTypes.forEach(animatesType => {
        options[animatesType]?.forEach((item, index) => {
          if(!compareIds(controlIds,item.controlIds)){
            return
          }
          item.passiveIds.forEach(passiveId => {
            let isCurrentTarget = compareIds(ids, passiveId)
            if (isCurrentTarget) {
              if (item.variable) {
                for (let key in item.variable) {
                  if(key === 'colorArr'){
                    // 做为颜色设置的值，不进行变量拼接
                    continue
                  }
                  // 新的颜色值模式
                  if(['hoverBackground','clickBackground'].indexOf(key) !== -1 && Array.isArray(item.variable[key])){
                     let bgStyle = this.getBackGroundStyle(item.variable[key])
                     animateVariable[`--${key}`] = bgStyle
                     continue
                  }
                  if(key.toLowerCase().indexOf("color")>-1 && typeof item.variable[key] == "object"){
                    console.log(this.$parseColor(item.variable[key]))
                    animateVariable[`--${key}`] = this.$parseColor(item.variable[key])
                    continue
                  }
                  // 判断当前变量是否固定
                  // 如圆角，动画的初始值，用户随时可以发生改变，则不固定
                  let variableValue = item.variable[key]
                  let variableArr = typeof variableValue === "string" ? variableValue.split("_") : []
                  if (variableArr[0] === "var") {
                    // 格式为  var_变量名称（动画取）_属性1,属性2 _单位
                    let propArr = variableArr[2] ? variableArr[2].split(",") : []
                    let val = "",
                      unit = variableArr[3] || ""
                    propArr?.forEach(item => {
                      let itemName = item.split(".")
                        if (itemName[0] === "page") {
                          let value = isSsrPage()
                            ? this.$store.state.page[itemName[1]]
                            : this.$store.state[this.request_prefix].page[itemName[1]]
                          val += value + unit + " "
                        } else {
                          val += options[item] + unit + " "
                        }
                    })
                     animateVariable[`--${item.triggerType}${variableArr[1]}`] = val
                  }else if(variableArr[0] === "options"){
                     // 需要修改options 里面的属性  不加变量
                  }else{
                     animateVariable[`--${key}`] = item.variable[key]
                  }
                }
              }
            }
          })
        })
      })
      if(animateDom){
        for(let key in animateVariable){
          animateDom.parentNode.style.setProperty(key+'',animateVariable[key])
        }
      }
      return {
        ...animateVariable
      }
    },
    // 获取页面加载组件动画组合的样式
    getPageLoadAnimateGroupClass(defautOptions, _ids) {
      this.pageLoadAnimateGroupClass = {}
      let options = this.getAnimateOption(_ids)
      // 新加了组合动画
      if(options.animateGroup){
        let animationName = options.animateGroup.direction?`${options.animateGroup.animateType}-${options.animateGroup.direction}`:`${options.animateGroup.animateType}`
        this.pageLoadAnimateGroupClass = {
          animateId:_ids,
          pageLoadName: `${animationName}`,
          animateDuration: options.animateGroup.animateDuration,
          animateDelay:options.animateGroup.animateDelay,
          // /*循环动画只在预览页执行，编辑页一直执行太怪异*/
          // animateIteration: options.animateGroup.isRepeat ?'animate__infinite':''
        }
      }
    },
    // 获取页面加载的样式
    getPageLoadAnimateClass(defautOptions, _ids) {
      this.pageLoadAnimateClass = []
      let options = this.getAnimateOption(_ids)
      options.pageloadAnimates?.forEach((item, index) => {
        let pageLoadnoRepeatAnimateClass = ""
        let pageLoadRepeatAnimateClass = ""
        item.passiveIds.forEach(passiveId => {
          let isCurrentTarget = compareIds(_ids, passiveId)
          if (isCurrentTarget) {
            if (item.animationIterationCount && item.animationIterationCount > 1) {
              pageLoadRepeatAnimateClass += `${item.animateClass} `
            } else {
              pageLoadnoRepeatAnimateClass += `${item.animateClass} `
            }
            this.pageLoadAnimateClass.push({
              animateId: item.animateId,
              pageLoadName1: pageLoadnoRepeatAnimateClass,
              pageLoadName2: pageLoadRepeatAnimateClass,
              animateDuration: item.animateDuration,
              animateDelay:item.animateDelay
            })
            return this.pageLoadAnimateClass
          }
        })
      })
    },
    // 获取鼠标悬浮的样式
    getHoverAnimateClass(ids) {
      let hoverAnimateClassArr = []
      let options = this.getAnimateOption(ids)
      this.hoverAnimateOptions=[]
      options?.hoverAnimates?.forEach((item, index) => {
        let hoverAnimateClass = "",
          animateLeaveClass = ""
        if (item.variable) {
          for (let key in item.variable) {
            let variableValue = item.variable[key]
            let variableArr = typeof variableValue === "string" ? variableValue.split("_") : []
            if(variableArr[0] === "options"){
              // 需要修改options 里面的属性
              let currentVal = options[variableArr[1]]
              this.hoverAnimateOptions.push(`${variableArr[1]}---${variableArr[2]}---${currentVal}---${JSON.stringify(item.passiveIds)}`)
            }
          }
        }
        item.passiveIds.forEach(passiveId => {
          let isCurrentTarget = compareIds(ids, passiveId)
          if (isCurrentTarget) {
            hoverAnimateClass += `${item.animateClass} `
            animateLeaveClass += `${item.animateLeaveClass} `
            hoverAnimateClassArr.push({
              animateId: item.animateId,
              animateClass: hoverAnimateClass,
              animateLeaveClass: animateLeaveClass,
              animateDuration: item.animateDuration,
              animateDelay:item.animateDelay
            })
          }
        })
      })
      return hoverAnimateClassArr
    },
    // 获取鼠标点击的样式
    getClickAnimateClass(ids) {
      let clickAnimateClassArr = []
      let options = this.getAnimateOption(ids)
      this.clickAnimateOptions = []
      options?.clickAnimates?.forEach((item, index) => {
        let clickAnimateClass = ""
        if (item.variable) {
          for (let key in item.variable) {
            let variableValue = item.variable[key]
            let variableArr = typeof variableValue === "string" ? variableValue.split("_") : []
            if(variableArr[0] === "options"){
              // 需要修改options 里面的属性
              let currentVal = options[variableArr[1]]
              this.clickAnimateOptions.push(`${variableArr[1]}---${variableArr[2]}---${currentVal}---${JSON.stringify(item.passiveIds)}`)
            }
          }
        }
        item.passiveIds.forEach(passiveId => {
          let isCurrentTarget = compareIds(ids, passiveId)
          if (isCurrentTarget) {
            clickAnimateClass += `${item.animateClass} `
            clickAnimateClassArr.push({
              animateId: item.animateId,
              animateClass: clickAnimateClass,
              animateDuration: item.animateDuration,
              animateDelay:item.animateDelay
            })
          }
        })
      })
      return clickAnimateClassArr
    },
    pageloadHandleAnimateGroup() {
      // 用于页面预览预设的动画组个
      this.currentEl.addEventListener("pageScan1", this.animateGroupHandle)
    },
    pageloadHandleAnimate() {
      // 用于页面预览效果
      this.currentEl.addEventListener("pageScan", this.pageloadHandle)
    },
    // 鼠标悬浮激活动画
    mouseoverHandleAnimate() {
      this.currentEl.addEventListener("scan", this.mouseenterHandle)
    },
    // 点击组件激活动画
    clickHandleAnimate() {
      this.currentEl.addEventListener("clickScan", this.clickHandle)
    },
    animateGroupHandle(event){
      let ids = event.detail._ids || this.myid
      let options = this.getAnimateOption(ids)
      if (!options.animateGroup || !options.animateGroup.animateType) {
        return
      }
      this.getPageLoadAnimateGroupClass(options, ids)
      this.$changeOptionsEV(this.pageLoadAnimateGroupClass, "pageLoadAnimateGroupClass", false, undefined, this.myid)
      let currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
      currentDomClass = isExist(ids.elementInAutoLayoutId) ?`container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}` : currentDomClass
      // currentDomClass = ids.uid ? `${currentDomClass}-uid_${ids.uid}` : currentDomClass
      let animateDom = document.getElementsByClassName(currentDomClass)[0]
      if (!animateDom) {
        return
      }
      let animateVarDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
      this.getAnimateGroupVariableStyle(options,ids,animateVarDom)
      this.handlePageAnimateGroup(ids)
    },
    // 处理页面加载动画组合
    handlePageAnimateGroup(rectIds) {
      let currentDomClass = `container_id_${rectIds.container_id}-rect_id_${rectIds.rect_id}`
      // currentDomClass = rectIds.uid ? `${currentDomClass}-uid_${rectIds.uid}` : currentDomClass
      currentDomClass = isExist(rectIds.elementInAutoLayoutId) ?`container_id_${rectIds.container_id}-rect_id_${rectIds.rect_id}-elementInAutoLayoutId_${rectIds.elementInAutoLayoutId}-path_${rectIds.path ? rectIds.path.join('') : rectIds.path}` : currentDomClass
      let animateDom = document.getElementsByClassName(currentDomClass)[0]
      animateDom =
        animateDom && animateDom.getElementsByClassName("rect")[0]
          ? animateDom.getElementsByClassName("rect")[0]
          : animateDom
      if (animateDom) {
        // 清除上一次的动画
        let classList = animateDom.classList
        if(classList.contains("animate__infinite")) {
          classList.remove("animate__infinite")
          for(let k=0;k<classList.length;k++){
            if(classList[k].indexOf("__scroll")>-1 || classList[k].indexOf( "__defaultStyle")>-1){
              classList.remove(classList[k])
            }
          }
        }

        // 找 restIds对应的 pageLoadAnimateClass
        let options = this.$getOptions(rectIds)
        let animateClassObject = options.pageLoadAnimateGroupClass
        let animateClass = animateClassObject.pageLoadName
        if (animateClass.length === 0) {
          return
        }
        if(animateClassObject.animateIteration){
          animateDom.classList.add(animateClassObject.animateIteration)
        }
        animateDom.classList.remove("animate__animated")
        animateDom.classList.add(`${animateClass}__defaultStyle`)
        setTimeout(()=>{
          animateDom.classList.add(animateClass)
          animateDom.classList.add(`${animateClass}__scroll`)
        },5)
        if(!animateClassObject.animateIteration){
          setTimeout(() => {
            animateDom.classList.remove(`${animateClass}__scroll`)
            animateDom.classList.remove(`${animateClass}`)
            animateDom.classList.remove(`${animateClass}__defaultStyle`)
          }, options.animateGroup.animateDuration + options.animateGroup.animateDelay )
        }
      }
    },
    pageloadHandle(event) {
      // let options = this.colsOptions?.componentBoxOptions || this.options
      let ids = event.detail._ids || this.myid
      let options = this.getAnimateOption(ids)
      if (options.pageloadAnimates?.length === 0) {
        return
      }
      this.getPageLoadAnimateClass(options, ids)
      this.$changeOptionsEV(this.pageLoadAnimateClass, "pageLoadAnimateClass", false, undefined, this.myid)
      // let ids = this.ids || this.$store.state.states.activeID
      let currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
      currentDomClass = isExist(ids.elementInAutoLayoutId) ?`container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}` : currentDomClass
      // currentDomClass = ids.uid ? `${currentDomClass}-uid_${ids.uid}` : currentDomClass
      let animateDom = document.getElementsByClassName(currentDomClass)[0]
      if (!animateDom) {
        return
      }
      let animateVarDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
      this.getAnimateVariableStyle(options,ids,animateVarDom,ids)
      animateVarDom.removeAttribute("animated")

      // 可视区域内 只执行一次动画
      //  编辑页可执行多次
      let animateIds = [],
        passiveIds = []
      options.pageloadAnimates.forEach(animate => {
        // 对比controlIds 是不是等于当前对象的id
        let isCurrentIds = compareIds(animate.controlIds, animate.ids)
        if (isCurrentIds) {
          animateIds.push(animate.animateId)
          passiveIds = passiveIds.concat(animate.passiveIds)
        }
      })
      this.handlePassiveAnimate(passiveIds, animateIds, "pageload",undefined,ids)
    },
    clickHandle(e) {
      let ids = e.detail._ids || this.myid
      let options = this.colsOptions?.componentBoxOptions || this.options
      if (!options || !options.clickAnimates || options.clickAnimates?.length === 0) {
        return
      }
      let animateIds = [],
        passiveIds = [],
        parentOverflowHidden = []  //针对某些动画 父级要设置超出隐藏 目前有图片缩放

      options.clickAnimates.forEach((animate,index) => {
        // 对比controlIds 是不是等于当前对象的id
        let isCurrentIds = compareIds(animate.controlIds, ids)
        let isParentOverflowHidden = false
        if (isCurrentIds) {
          if(animate.animateType === 'imageScale'){
            isParentOverflowHidden = true
          }
          animateIds.push(animate.animateId)
          animate.passiveIds.forEach(item=>{
            parentOverflowHidden.push(isParentOverflowHidden)
          })
          passiveIds = passiveIds.concat(animate.passiveIds)
        }
        this.pageScroll(animate)
      })
      this.handlePassiveAnimate(passiveIds, animateIds, "click",parentOverflowHidden,ids)
    },
    // 页面滚动事件
    pageScroll(animate) {
      if (animate.animateType !== "pageScroll") {
        return
      }
      let scrollTop = 0 //默认返回顶部
      let target = this.$event.getIdsByStrId(animate.passiveIds[0])
      const targetDom = document.getElementsByClassName(target)
      const scrollDom = document.getElementById("vueRulerContent").getElementsByClassName("el-scrollbar__wrap")[0]
      if (targetDom[0]) {
        scrollTop = targetDom[0].getBoundingClientRect().top + scrollDom.scrollTop
      }
      scrollDom?.scrollTo({ top: scrollTop, behavior: "smooth" })
    },
    mouseenterHandle(e) {
      let ids = e.detail._ids || this.myid
      let options = this.colsOptions?.componentBoxOptions || this.options
      if (!options.hoverAnimates || options.hoverAnimates?.length === 0) {
        return
      }
      console.log("options.hoverAnimates",options.hoverAnimates)
      // this.getHoverAnimateClass()
      let animateIds = [],
        passiveIds = [],
        parentOverflowHidden = [] //针对某些动画 父级要设置超出隐藏 目前有图片缩放
      options.hoverAnimates?.forEach((animate,index) => {
        // 对比controlIds 是不是等于当前对象的id
        // let isCurrentIds = compareIds(animate.controlIds, animate.ids)
        let isCurrentIds = compareIds(animate.controlIds, ids)
        let isParentOverflowHidden = false
        if (isCurrentIds) {
          if(animate.animateType === 'imageScale'){
            isParentOverflowHidden = true
          }
          animateIds.push(animate.animateId)
          animate.passiveIds.forEach(item=>{
            parentOverflowHidden.push(isParentOverflowHidden)
          })
          passiveIds = passiveIds.concat(animate.passiveIds)
        }
        this.pageScroll(animate)
      })
      if (passiveIds.length === 0) {
        return
      }
      this.handlePassiveAnimate(passiveIds, animateIds, "hover",parentOverflowHidden,ids)
    },
    // 处理页面加载动画
    handlePageAnimate(rectIds, animateIds, rect) {
      let currentDomClass = `container_id_${rectIds.container_id}-rect_id_${rectIds.rect_id}`
      // currentDomClass = rectIds.uid ? `${currentDomClass}-uid_${rectIds.uid}` : currentDomClass
      currentDomClass = isExist(rectIds.elementInAutoLayoutId) ?`container_id_${rectIds.container_id}-rect_id_${rectIds.rect_id}-elementInAutoLayoutId_${rectIds.elementInAutoLayoutId}-path_${rectIds.path ? rectIds.path.join('') : rectIds.path}` : currentDomClass
      let animateDom = document.getElementsByClassName(currentDomClass)[0]
      animateDom =
        animateDom && animateDom.getElementsByClassName("rect")[0]
          ? animateDom.getElementsByClassName("rect")[0]
          : animateDom
      if (animateDom) {
        // 找 restIds对应的 pageLoadAnimateClass
        let animateClassObject = this.$getOptions(rectIds).pageLoadAnimateClass
        let animateClass1 = "",animateClass2 = "",animateDuration = "",animateDelay = "",
            maxAnimateEndTime = 0
        animateIds.forEach((animateId,index) => {
          let object = animateClassObject.find(item => item.animateId === animateId)
          let firstDot = index ===0?'':','
          if (object) {
            animateDuration += firstDot+object.animateDuration + "ms"
            animateDelay += firstDot+object.animateDelay + "ms "
            animateClass1 += ' ' + object.pageLoadName1.trim()
            animateClass2 += ' ' + object.pageLoadName2.trim()
            maxAnimateEndTime = Math.max(maxAnimateEndTime, object.animateDuration + object.animateDelay)
          }
        })
        let hasAnimated = animateDom.getAttribute("animated")
        // 已经触发过的单次动画 不再进行触发
        // let animateClass = hasAnimated ? animateClass2 : animateClass1 + " " + animateClass2
        // 编辑页可以重复进行动画
        let animateClass = animateClass1.trim() + " " + animateClass2.trim()
        animateClass = animateClass ? animateClass.trim() : ""
        // if (animateDom.classList.value.indexOf("animate__animated") > -1 || animateClass.length === 0) {
        if (animateClass.length === 0) {
          return
        }
        console.log("animateClass",animateClass)
        animateDom.classList.add("animate__animated")
        // 此表示用来区分当前组件是否已经进行过动画（动画分单次触发和多次触发）
        // 编辑页允许执行多次
        // animateDom.setAttribute("animated", "true")
        animateClass = animateClass.split(" ") || []
        animateClass = animateClass.filter(item => item !== '' && item !== null && item !== undefined && item === item);
        animateClass.forEach(item => {
          item && animateDom.classList.add(item)
        })
        let animationName = animateClass.join(",")
        animateDom.style.animationName = animationName
        animateDom.style.animationDuration = animateDuration
        animateDom.style.animationDelay = animateDelay
console.log("animationName",animationName)
        setTimeout(() => {
          animateDom.style.animationName = ""
          animateClass.forEach(item => {
            item && animateDom.classList.remove(item)
          })
        }, maxAnimateEndTime)
        // animateDom.addEventListener("webkitAnimationEnd", function () {
        //   animateDom.style.animationName = ""
        //   animateClass.forEach(item => {
        //     animateDom.classList.remove(item)
        //   })
        // })
        // }
      }
    },
    /** 处理鼠标/点击事件动画
     * controlIds 控制动画的组件
    *  rectIds  需要执行动画的组件id
    *  animateIds  需要执行的动画 id
    // *   animateDuration ,animateDelay  拼接好的动画过渡时间及动画延迟时间
    *   eventType 触发动画的方式，如click
    *   maxAnimateEndTime 动画结束时间
    *   parentOverflowHidden 父级dom是否需要超出隐藏
    * */
    handleAnimate(rectIds, animateIds, eventType,parentOverflowHidden,controlIds) {
      let ids = idsFilter(rectIds)
      let currentDomClass, animateDom, animateDomArr = []
      if(!ids){
        return
      }
      if(ids.cellId){
        // 新的列表数据组件中的子组件
        if(ids.elementInDataGridId){
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-cell_id_${ids.cellId}-elementInDataGridId_${ids.elementInDataGridId}`
          animateDom = document.getElementsByClassName(currentDomClass)[0]
          animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
        }else{
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-cell_id_${ids.cellId}`
          animateDom = document.getElementsByClassName(currentDomClass)[0]
          animateDom = animateDom.getElementsByClassName("dataGrid-cell-layout")[0]
        }
        animateDomArr =[animateDom]
      } else if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
        // 单元格
        currentDomClass = `componentBox_after${ids.uid}`
        // animateDom = document.getElementById(currentDomClass)
        animateDom = document.getElementById(ids.uid)
        animateDomArr = [animateDom]
      } else if (ids.hasOwnProperty("directionIndex")) {
        // 边栏内组件
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        // currentDomClass = ids.hasOwnProperty("uid") ? currentDomClass + `-uid_${ids.uid}` : currentDomClass
        currentDomClass = ids.hasOwnProperty("directionIndex")
          ? currentDomClass + `-directionIndex_${ids.directionIndex}` + `-elementInLayoutId_${ids.elementInLayoutId}`
          : currentDomClass
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
        //   // 自由布局、轮播这种容器组件绑定在容器上，其他绑定在子元素上（基础元素的样式都绑定在子元素上）
        animateDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
        animateDomArr = [animateDom]
      } else if (ids.hasOwnProperty("elementInAutoLayoutId")) {
        // 自动布局中的组件
        let tempRect = this.getAttrById(this.$store.state[this.request_prefix], ids, "rect").options
        if (ids.uid) {
          if (tempRect.innerElement === "cxAutoLayout") {// 自由布局在自动布局中
            if (ids.hasOwnProperty("elementInLayoutId")) {
              currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-uid_${ids.uid}-elementInLayoutId_${ids.elementInLayoutId}`
            }
          } else {// 自动布局在自由布局中
            currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-uid_${ids.uid}-elementInLayoutId_${ids.elementInLayoutId}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}`
          }
        } else {
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}`
        }
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
        //   // 自由布局、轮播这种容器组件绑定在容器上，其他绑定在子元素上（基础元素的样式都绑定在子元素上）
        animateDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
        animateDomArr =[animateDom]
      } else if (ids.hasOwnProperty("elementInLayoutId")) {
        // 单元格内组件
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        currentDomClass = ids.hasOwnProperty("uid") ? currentDomClass + `-uid_${ids.uid}` : currentDomClass
        currentDomClass = ids.hasOwnProperty("elementInLayoutId")
          ? currentDomClass + `-elementInLayoutId_${ids.elementInLayoutId}`
          : currentDomClass
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
        //   // 自由布局、轮播这种容器组件绑定在容器上，其他绑定在子元素上（基础元素的样式都绑定在子元素上）
        animateDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
        animateDomArr = [animateDom]
      } else if(ids.hasOwnProperty("elementInSwiperId")) {
        animateDom = []
        let animateDoms = document.getElementsByClassName( `container_id_${ids.container_id}-rect_id_${ids.rect_id}-swiperContent_id_${ids.swiperContent_id}-elementInSwiperId_${ids.elementInSwiperId}`)
        for(let i=0;i<animateDoms.length;i++){
          let tempData = animateDoms[i]
          tempData = tempData ? tempData.getElementsByClassName("rect")[0] : null
          //   // 自由布局、轮播这种容器组件绑定在容器上，其他绑定在子元素上（基础元素的样式都绑定在子元素上）
          tempData = tempData?.childNodes.nodeType === 1 ? tempData.childNodes[0] : tempData
          animateDom.push(tempData)
        }
        animateDomArr = animateDom
      } else {
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
        //   // 自由布局、轮播这种容器组件绑定在容器上，其他绑定在子元素上（基础元素的样式都绑定在子元素上）
        animateDom = animateDom?.childNodes.nodeType === 1 ? animateDom.childNodes[0] : animateDom
        animateDomArr = [animateDom]
      }
      animateDomArr.forEach(animateDom=>{
        if (animateDom) {
          //  此时动态写入 被动画的变量值
          this.getAnimateVariableStyle(null,ids,animateDom,controlIds)
          let getAnimateClassName = eventType === "hover" ? "getHoverAnimateClass" : "getClickAnimateClass"
          let animateClassObject = this[getAnimateClassName](ids)
          let animateClass = "",animateDuration = "",animateDelay = "",
            animateLeaveClass = "",maxAnimateEndTime = 0
          animateIds.forEach((animateId,index) => {
            let object = animateClassObject.find(item => item.animateId === animateId)
            let firstDot = index ===0?'':','
            if (object) {
              animateDuration += firstDot+object.animateDuration + "ms"
              animateDelay += firstDot+object.animateDelay + "ms "
              animateClass += object.animateClass.trim() + " "
              animateLeaveClass += object.animateLeaveClass?.trim() + " "
              maxAnimateEndTime = Math.max(maxAnimateEndTime, object.animateDuration + object.animateDelay)
            }
          })
          animateClass = animateClass ? animateClass.trim() : ""
          animateLeaveClass = animateLeaveClass ? animateLeaveClass.trim() : ""
          if (animateClass.length === 0) {
            return
          }
          // 判断如果有改变options的情况需要改变options
          let animateOptions = eventType === "hover" ? "hoverAnimateOptions" : "clickAnimateOptions"
          let variableArr = []
          console.log(" this[animateOptions]", this[animateOptions])
          this[animateOptions].forEach(option=>{
            let optionArr = option.split("---")
            let passiveIds = JSON.parse(optionArr[3])
            if(optionArr.length>1){
              for(let i=0;i<passiveIds.length;i++){
                if(compareIds(passiveIds[i], rectIds)){
                  variableArr.push({value:optionArr[0],id:passiveIds[i]})
                  this.$changeOptionsEV(optionArr[1], optionArr[0], false,null, passiveIds[i])
                  break
                }
              }
            }
          })
          // 动画之前先清除上次动画的遗留class
          const removeClassList = Array.from(animateDom.classList).filter(it => it.includes("cx_hover"))
          animateDom.classList.remove(...removeClassList)

          if(parentOverflowHidden){
            animateDom.parentNode.classList.add("overflowHid")
            let childNodes = animateDom.childNodes[0]
            let thisParentNode = animateDom.parentNode
            let borderRadius = childNodes.style.borderRadius
            let borderWidth = childNodes.style.borderWidth
            let borderStyle = childNodes.style.borderStyle
            let borderColor = childNodes.style.borderColor
            let boxShadow = childNodes.style.boxShadow
            thisParentNode.style.borderRadius = borderRadius
            thisParentNode.style.boxShadow = boxShadow
            let box1 = document.createElement('div');
            box1.style.border= borderWidth + ' '+borderStyle+ ' '+borderColor;
            box1.style.borderRadius= borderRadius
            box1.setAttribute('class', 'imgScalcBorder');
            thisParentNode.appendChild(box1);
          }

          animateDom.classList.add("animate__animated")
          animateClass = animateClass.split(" ") || []
          animateClass = animateClass.filter(item => item !== '' && item !== null && item !== undefined && item === item);
          animateLeaveClass = animateLeaveClass.split(" ") || []
          animateLeaveClass = animateLeaveClass.filter(item => item !== '' && item !== null && item !== undefined && item === item);
          animateLeaveClass.forEach(item => {
            if (item && item.length > 0) {
              animateDom.classList.remove(item)
            }
          })
          animateClass.forEach(item => {
            animateDom.classList.add(item)
          })
          let animationName = animateClass.join(",")
          animateDom.style.animationName = animationName
          animateDom.style.animationDuration = animateDuration.trim()
          animateDom.style.animationDelay = animateDelay.trim()

          // 多组动画 不能用 webkitAnimationEnd 这个方法判断动画结束
          setTimeout(() => {
            animateClass.forEach(item => {
              if (item && item.length > 0) {
                animateDom.classList.remove(item)
              }
            })
            animateLeaveClass.forEach(item => {
              if (item && item.length > 0) {
                animateDom.classList.add(item)
              }
            })
            setTimeout(()=>{
              // 图片缩放之后加了overflowHidden  先清除掉 后续优化效果
              animateLeaveClass.forEach(item => {
                if (item && item.length > 0) {
                  animateDom.classList.remove(item)
                }
              })
              let parentNode = animateDom.parentNode
              parentNode.classList.remove('overflowHid')
              parentNode.style.borderRadius = ""
              parentNode.style.boxShadow = ""
              parentNode.style.outline = ""
              let removeDom = parentNode.getElementsByClassName("imgScalcBorder")
              removeDom[0]?.remove()
            },50)
            animateDom.style.animationName = ""
            // 清除掉之前的修改好的options属性
            variableArr.forEach(item=>{
              this.$changeOptionsEV(0, item.value, false,null, item.id)
            })
          }, maxAnimateEndTime)
          //  预览页面才有 鼠标移除事件
        }
      })
    },
    // 处理被动组件的动画
    handlePassiveAnimate(passiveIds, animateIds,eventType,parentOverflowHidden,controlIds) {
      let handleAnimateEvent = eventType === "pageload" ? "handlePageAnimate" : "handleAnimate"
      passiveIds?.forEach((item,index) => {
        this[handleAnimateEvent](item, animateIds, eventType,parentOverflowHidden?parentOverflowHidden[index]:false,controlIds)
      })
    }
  }
}
